/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:37:54
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import {
  TOGGLE_FORM_SENDING_STATUS,
} from './mutation-types';

export default {
  [TOGGLE_FORM_SENDING_STATUS](state) {
    const _state = state;
    _state.complainsFormHasBeenSent = !state.complainsFormHasBeenSent;
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/Complains/mutations.js